const CountDown = () => {

    // Ustaw datę do odliczania
    var countDownDate = new Date("Dec 5, 2023 12:00:00").getTime();
    var countDownWrapper = document.getElementsByClassName('countdown-wrapper');

    if(countDownWrapper) {
        [...countDownWrapper].forEach(element => {

            var countDownDays = element.querySelector('.countdown-wrapper__item-value.days');
            var countDownHours = element.querySelector('.countdown-wrapper__item-value.hours');
            var countDownMinutes = element.querySelector('.countdown-wrapper__item-value.minutes');
            var countDownSeconds = element.querySelector('.countdown-wrapper__item-value.seconds');

            // Aktualizuj odliczanie co sekundę
            var x = setInterval(function() {
    
                // Pobierz aktualną datę i czas
                var now = new Date().getTime();
                
                // Znajdź różnicę między teraz a datą odliczania
                var distance = countDownDate - now;
    
                // Obliczenia czasu dla dni, godzin, minut i sekund
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
                countDownDays.innerHTML = (days < 10) ? '0' + days : days;
                countDownHours.innerHTML = (hours < 10) ? '0' + hours : hours;
                countDownMinutes.innerHTML = (minutes < 10) ? '0' + minutes : minutes;
                countDownSeconds.innerHTML = (seconds < 10) ? '0' + seconds : seconds;
    
                // Jeśli odliczanie jest zakończone, wyświetl tekst
                if (distance < 0) {
                    clearInterval(x);
                }
            }, 1000);
        });
    }

    var countDownPromoBox = document.getElementsByClassName('coupon-countdown-js')[0];
    var couponPromoBoxWrapper = document.getElementsByClassName('coupon-countdown')[0];

    if(countDownPromoBox) {

        var countDownDatePromo = countDownPromoBox.dataset.expiryDate;
        var countDownDatePromoTime = new Date(countDownDatePromo).getTime();
        var countDownDaysPromo = document.querySelector('.coupon-countdown-days-js');
        var countDownHoursPromo = document.querySelector('.coupon-countdown-hours-js');
        var countDownMinutesPromo = document.querySelector('.coupon-countdown-minutes-js');
        var countDownSecondsPromo = document.querySelector('.coupon-countdown-seconds-js');

        // Update the count down every 1 second
        var x = setInterval(function() {

            // Get today's date and time
            var now = new Date().getTime();
            
            // Find the distance between now and the count down date
            var distance = countDownDatePromoTime - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // countDownDays.innerHTML = days;
            if(countDownDaysPromo) {
                countDownDaysPromo.innerHTML = (days < 10) ? '0' + days : days;
            }
            countDownHoursPromo.innerHTML = (hours < 10) ? '0' + hours : hours;
            countDownMinutesPromo.innerHTML = (minutes < 10) ? '0' + minutes : minutes;
            countDownSecondsPromo.innerHTML = (seconds < 10) ? '0' + seconds : seconds;

            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(x);
                if(countDownDaysPromo) {
                    countDownDaysPromo.innerHTML = '00';
                }
                countDownHoursPromo.innerHTML = '00';
                countDownMinutesPromo.innerHTML = '00';
                countDownSecondsPromo.innerHTML = '00';
                if(couponPromoBoxWrapper) {
                    if(couponPromoBoxWrapper.classList.contains('active')) {
                        couponPromoBoxWrapper.classList.remove('active');
                        couponPromoBoxWrapper.classList.add('inactive');
                        couponPromoBoxWrapper.classList.add('date-inactive');
                    }
                }
            }
        }, 1000);
    }

}

export default CountDown;